import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Layout from "../layout/Layout";
import VimList from "../pages/VimList/VimList";
import BmsList from "../pages/BmsList/BmsList";
import ViewDashboard from "../pages/Dashboard/ViewDashboard";
import BmsDashboard from "../pages/Dashboard/BmsDashboard";
import HistoricalData from "../pages/Dashboard/HistoricalData";

const AppRouter = () => {
  return (
    <Router>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Navigate to="/vim-list" replace />} />
          <Route path="/ViewDashboard/:deviceId" element={<ViewDashboard />} />
          <Route path="/ViewDashboard/:deviceId/historical" element={<HistoricalData />} />
          <Route path="/ViewDashboard/:deviceId/bms/:ecuid" element={<BmsDashboard />} />
          <Route path="/vim-list" element={<VimList />} />
          <Route path="/bms-list" element={<BmsList />} />
          {/* Add more routes as needed */}
          <Route path="*" element={<Navigate to="/vim-list" replace />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default AppRouter;
